import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=528e95aa&scoped=true&"
import script from "./Products.vue?vue&type=script&lang=ts&"
export * from "./Products.vue?vue&type=script&lang=ts&"
import style0 from "./Products.vue?vue&type=style&index=0&id=528e95aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528e95aa",
  null
  
)

export default component.exports